<template>
  <div class="w-full">
    <div class="">
      <div class="relative">
        <div class="absolute left-0 top-0" @click="$emit('closeRequired')">
          <img
            src="@/assets/images/all/close.svg"
            class="w-[30px] h-[30px] cursor-pointer full-screen-modal-close-button-black"
            alt=""
          />
        </div>
        <div class="">
          <div class="text-center font-bold title-color text-3xl">
            Modifier un produit
          </div>
          <div class="py-4"></div>
          <ProductForm
            :initialData="productData"
            :isEditing="true"
            @productSubmitted="handleSubmit"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ProductForm from './ProductForm.vue'

export default defineComponent({
  name: 'EditProduct',
  components: {
    ProductForm,
  },
  props: {
    productData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      eventsIds: [], // Stocke les IDs des écouteurs d'événements
    }
  },
  mounted() {
    // Écoute des événements pour la mise à jour du produit
    const id = this.$Events.handleEvent(
      'product_updated',
      this.onProductUpdated,
    )
    const id2 = this.$Events.handleEvent(
      'failed_to_update_product',
      this.onProductUpdateFailed,
    )
    this.eventsIds.push(id, id2)
  },
  beforeUnmount() {
    // Nettoyage des écouteurs d'événements
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    // Soumission du formulaire
    handleSubmit(formData) {
      console.log('Données du formulaire:', formData)
      this.$Events.dispatchEvent('product_ready_to_be_updated', formData)
      this.$Events.dispatchEvent('start_loading')
    },
    // Gestion de la mise à jour réussie
    onProductUpdated() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Produit mis à jour',
        body: 'Votre produit a été mis à jour avec succès',
      })
      this.$emit('closeRequired')
    },
    // Gestion de l'échec de la mise à jour
    onProductUpdateFailed() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Produit non mis à jour',
        body: 'Erreur de mise à jour du produit, veuillez réessayer',
      })
    },
  },
})
</script>

<style scoped></style>
